import React, { useEffect, useState } from "react";

import { useTranslation } from "@common/hooks/translation";
import { DocTypeEnum } from "@common/constants/enums/docType";
import Spinner from "@common/components/spinner";
import DocTypeInput from "./docTypeInput";

import "./style.scss";

// import { isValidDNI } from "@common/helpers/dni";

const VerificationPopup = ({ isOptional, config, onVerify, tickets, defer, className }) => {
	const t = useTranslation();

	const defaultDocType = config.verification.docTypes?.find(item => item.default)?.type;

	const [form, setForm] = useState({
		type: defaultDocType ? DocTypeEnum[defaultDocType] : DocTypeEnum.DNI,
		identifier: "",
	});

	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const { type } = form;

	useEffect(() => {
		setForm((oldForm) => ({ ...oldForm, identifier: '' }));
		setErrorMessage('');
	}, [type]);

	const onSkip = () => {
		defer.resolve({ skipped: true });
	}

	const onDone = async () => {
		// const isInvalidDNI = form.type === DocTypeEnum.DNI && !isValidDNI(form.identifier.replace(/-/g, ''))

		//if (isInvalidDNI) return setErrorMessage('DNI is invalid');
		//else setErrorMessage('');

		if (!form.identifier) {
			setErrorMessage('Field is missing');
			return;
		}

		setIsLoading(true);

		const data = await onVerify({
			...form,
			identifier: form.identifier.replace(/-/g, ''),
			tickets,
		});

		if (!data.success) {
			data.errorMessage && setErrorMessage(data.errorMessage);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			return defer.resolve(data.data);
		}
	};

	return (
		<div className={`${className} popup-content popup-small popup-verification`}>
			<p className="popup-title">{t("Enter Doc Number")}</p>

			<div className="popup-main-content">
				<i className="global-icon icon-add-person popup-main-icon" />

				<p className="verification-sub-title">{t("Please input your id number")}</p>

				{config.verification.docTypes?.length > 1 && (
					<>
						<p className="verification-placeholder">{t("Doc type")}</p>
						<div className="doc-types-wrp">
							{config.verification.docTypes.map(item => (
								<span
									className={form.type === DocTypeEnum[item.type] ? "doc-type-selected" : ""}
									onClick={() => setForm({ ...form, type: DocTypeEnum[item.type] })}
								>
									{item.name}
								</span>
							))}
						</div>
					</>
				)}

				<p className="verification-placeholder">{t("Document number")}</p>

				<DocTypeInput
					type={form.type}
					config={config}
					value={form.identifier}
					onChange={value => setForm({ ...form, identifier: value })}
					errorMessage={errorMessage}
				/>
			</div>

			<div className="popup-actions">
				<button className="popup-cancel-button" onClick={() => defer.resolve(null)}>
					{t("Cancel")}
				</button>
				<button className="popup-confirm-button" onClick={onDone}>
					{t("Check")}
					{isLoading && <Spinner />}
				</button>
				{isOptional && <button className="popup-confirm-button verification-not-registered-button" onClick={onSkip}>
					{t("I'm not registered yet")}
				</button>}
			</div>
		</div>
	);
};

export default VerificationPopup;
